import React from 'react';
import styles from './HeaderTagline.module.css';

const HeaderTagline = props => {
	return <p className={`${styles.HeaderTagline} ${props.passOnClasses}`}>{props.children}</p>
}

export default HeaderTagline;